import React from 'react';

export const SocialNetworkLink = ({title, link, icon: Icon}:any) => {
    return (
        <a href={link} rel="noreferrer" target="_blank">
            <div className='social-network-link'>
                <p>{title}</p>
                <Icon />
            </div>
        </a>
    );
};
